import { removeAllInjectedReducers } from './remove-all-injected-reducers';
import { removeAllInjectedSagas } from './remove-all-injected-sagas';
export var replaceReducersAndSagas = function (_a) {
    var fromState = _a.fromState, toState = _a.toState, store = _a.store, _b = _a.reducersNotToReplace, reducersNotToReplace = _b === void 0 ? [] : _b, _c = _a.sagasNotToReplace, sagasNotToReplace = _c === void 0 ? [] : _c;
    // define first route name to navigate from
    var coreRouteFromStateName = fromState && fromState.name ? fromState.name.split('.')[0] : null;
    // define first route name to navigate to
    var coreRouteToStateName = toState && toState.name ? toState.name.split('.')[0] : null;
    // replace all injected reducers and sagas
    if (toState && fromState && coreRouteToStateName !== coreRouteFromStateName) {
        removeAllInjectedReducers({ store: store, reducersNotToReplace: reducersNotToReplace });
        removeAllInjectedSagas({ store: store, sagasNotToReplace: sagasNotToReplace });
        // make some noise =)
        console.warn('ReduxStoreLoader replaced old reducers'); // eslint-disable-line
    }
};
